// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__13Yep","left":"InfoRow_left__1qjM9"};